'use strict';

angular.module('TurneroApp').service('authInterceptorService', [
    '$q',
    '$injector',
    '$location',
    '$window',
    'TurneroAppConstant',
    '$rootScope',
    '$localStorage',
    '$sessionStorage',
    'miDoctaModoService',
    function ($q, $injector, $location, $window, TurneroAppConstant, $rootScope, $localStorage, $sessionStorage, miDoctaModoService) {
        var seguridadService;
        var $state;

        this.request = function (config) {

            var url = config.url.replace($rootScope.urlHostServer, '');

            
            //Si la url del request solicita token
            if (
                !TurneroAppConstant.endpointsSinToken.includes(url)
                && !config.url.contains('html')
                && $location.path().indexOf('/cancelarturno/') == -1
            ) {


                var path = $location.path();
                config.headers = config.headers || {};

                if (!seguridadService) {
                    //injected manually to get around circular dependency problem.
                    seguridadService = $injector.get('seguridadService');
                }

                if (!$state) {
                    $state = $injector.get('$state');
                }

                //se agrega al header el centro de usuario seleccionado
                if ($state.includes('admin') && $sessionStorage.TurneroApp_CentroSeleccionado) {
                    config.headers.TurneroIdCentroAtencionSeleccionado = $sessionStorage.TurneroApp_CentroSeleccionado.id;
                }
                else if (($state.is('llamador') || $state.is('recepcion')) && $localStorage.TurneroApp_Authorization_Centro) {             
                    config.headers.TurneroIdCentroAtencionSeleccionado = $localStorage.TurneroApp_Authorization_Centro.split('|')[0];
                }

                //Se obtiene token dependiendo de donde se llame
                var getToken = path === '/llamador' || path === '/recepcion'
                    ? seguridadService.getTokenCentro.bind(seguridadService)
                    : seguridadService.getTokenCidi.bind(seguridadService)

                //retorna token que corresponda
                return getToken().then(function (token) {
					//15/04/2019 El backend NO lo usa ya...
                    //config.headers.Authorization = 'Bearer ' + token;
                    return config;
                });
            }

            return config;
        };

        this.responseError = function (rejection) {
            if (!seguridadService) {
                //injected manually to get around circular dependency problem.
                seguridadService = $injector.get('seguridadService');
            }

            var path = $location.path();
            var esModoClienteMiDocta = miDoctaModoService.estaActivo();

            switch (rejection.status) {
                case 401: //Unauthorized
                case 403: //Forbidden
                    var urlPedido = ((rejection.config && rejection.config.url) || '').toLowerCase();
                    var es401403DelLogin = urlPedido.indexOf('api/login') !== -1;

                    //Se desloguea la aplicación
                    seguridadService.logOut();
                    if (es401403DelLogin) {
                        break;
                    }
                    if (path === '/llamador' || path === '/recepcion') {
                        $window.location.reload();
                    } else if (esModoClienteMiDocta) {
                        $window.location.href = miDoctaModoService.urlIframeError('sesion-expirada');
                    } else {
                        //Redirecciona a CiDI Login
                        $window.location.href = TurneroAppConstant.vedi.url + TurneroAppConstant.vedi.endpoint.login + TurneroAppConstant.vedi.veDiIdAplicacion;
                    }
                    break;
                case 409: //Conflict
                    //El Backend indica que la Cookie CiDi NO coincide con la de Turnero
                    seguridadService.logOut();
                    if (esModoClienteMiDocta) {
                        // En modo iframe Mi Docta el reload entra en loop porque el VeDiSesionId
                        // ya fue consumido. Mejor mostrar el cartel del iframe y pedir reingresar.
                        $window.location.href = miDoctaModoService.urlIframeError('sesion-expirada');
                    } else {
                        $window.location.reload();
                    }
                    break;
                case 406: //Not Acceptable
                    if (esModoClienteMiDocta) {
                        // No salir a CiDi, mantener al usuario dentro del flujo iframe.
                        $window.location.href = miDoctaModoService.urlIframeError('sesion-expirada');
                    } else {
                        $window.location.reload(true);
                        $window.location.href = TurneroAppConstant.vedi.ciDiUrlRelacion + TurneroAppConstant.vedi.ciDiIdAplicacion;
                    }
                    break;
            }

            //Se retorna que la petición ha sido rechazada
            return $q.reject(rejection);
        };
    }]);



// WEBPACK FOOTER //
// ./app/components/general/authInterceptorService.js